import React from "react";

const cards = [
  { label: "Email", value: "hello@musicuntamed.com" },
  { label: "Phone", value: "+1 (000) 000-0000" },
  { label: "WhatsApp", value: "Chat with our team" },
  { label: "Business Hours", value: "Mon–Fri, 9am–6pm WAT" }
];

export default function ContactInfoCards() {
  return (
    <section className="mu-section pb-0">
      <div className="container">
        <div className="row g-3">
          {cards.map((c) => (
            <div className="col-6 col-lg-3" key={c.label}>
              <div className="contact-info-card">
                <div className="contact-info-icon"></div>
                <h6>{c.label}</h6>
                <p>{c.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
